import groupBy from "lodash/groupBy";

import { SplitAction } from "../booking_edit_mode_store.types";

export type SplitOperation = {
  bookingId: number;
  splitDates: string[];
};

export const operationsFromOperationsHistory = (operationsHistory: SplitAction[]): SplitOperation[] => {
  const splitActionsByBookingId = groupBy(operationsHistory, "bookingId");

  return Object.keys(splitActionsByBookingId).map((bookingId) => ({
    bookingId: parseInt(bookingId),
    splitDates: splitActionsByBookingId[bookingId].map(({ splitDate }) => splitDate)
  }));
};
